import { Injectable } from '@angular/core';
import { SmartBannerEntity } from '@main/smart-banner/const';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { LoadSmartBanner } from '../store';
import * as SmartBannerSelectors from '../store/selectors/smart-banner.selectors';
import { StateWithSmartBanner } from '../store/smart-banner-state';

@Injectable({ providedIn: 'root' })
export class SmartBannerFacade {
  private lastLoadedCityCode: string | null = null;

  constructor(private store: Store<StateWithSmartBanner>) {}

  loadSmartBanner(cityCode: string): void {
    if (this.lastLoadedCityCode === cityCode) {
      return;
    }

    this.lastLoadedCityCode = cityCode;
    this.store.dispatch(new LoadSmartBanner(cityCode));
  }

  getSmartBannerState(): Observable<StateUtils.LoaderState<SmartBannerEntity>> {
    return this.store.select(SmartBannerSelectors.getSmartBannerState);
  }

  getSmartBanner(): Observable<SmartBannerEntity | null> {
    return this.store.select(SmartBannerSelectors.getSmartBannerValue);
  }

  getSmartBannerLoading(): Observable<boolean> {
    return this.store.select(SmartBannerSelectors.getSmartBannerLoading);
  }

  getSmartBannerError(): Observable<boolean> {
    return this.store.select(SmartBannerSelectors.getSmartBannerError);
  }

  getSmartBannerSuccess(): Observable<boolean> {
    return this.store.select(SmartBannerSelectors.getSmartBannerSuccess);
  }
}
